module.exports = __webpack_public_path__ + "static/img/stab_425_havok.97ae8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/stab_425_havok.jpg
// module id = nwzZ
// module chunks = 0